import Dashboard from '../components/dashboard/Dashboard';

import { PageTitle } from '../../../../_metronic/layout/core';

export default function DashboardPage() {
  return (
    <>
      <PageTitle>DevOps - Dashboard</PageTitle>
      <Dashboard />
    </>
  );
}
